// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"be73a770","921":"67a10793"}[chunkId] + ".chunk.js";
};